const toggleHeader = () => {
  const header = document.getElementById('global_header')
  const hight = header.offsetHeight / 2
  let offset = 0
  let lastPosition = 0
  let ticking = false

  function onScroll() {
    if (lastPosition > hight) {
      if (lastPosition > offset) {
        header.classList.add('is-hide')
      } else {
        header.classList.remove('is-hide')
      }
      offset = lastPosition
    }
  }

  window.addEventListener('scroll', () => {
    lastPosition = window.scrollY
    if (!ticking) {
      window.requestAnimationFrame(function () {
        onScroll(lastPosition)
        ticking = false
      })
      ticking = true
    }
  })
}

export default toggleHeader